import * as React from 'react';
import { RootContext, MnInputSelect, SvgLanguageIcon } from '../../../index';

export default class Footer extends React.Component {
  static contextType = RootContext;
  render () {
    return (
      <div className="p-footer">
        <div className="nav">
          <div><a target="_blank" rel="noreferrer" href="https://medicalnote.co.jp/">{this.context.t('Footer.our_company')}</a></div>
          <div><a target="_blank" rel="noreferrer" href="https://medicalnote.co.jp/privacy">{this.context.t('Footer.Privacy_Policy')}</a></div>
          <div><a target="_blank" rel="noreferrer" href="/institutions/terms">{this.context.t('Footer.Terms')}</a></div>
          <div><a target="_blank" rel="noreferrer" href="/institutions/regional_medical_cooperation_terms">{this.context.t('Footer.RegionalMedicalCooperationTerms')}</a></div>
          <div><a target="_blank" rel="noreferrer" href="/institutions/specified_commercial_transactions_law">{this.context.t('Footer.Specified_Commercial_Transaction_Law')}</a></div>
        </div>
        <div className="language">
          <div>© MedicalNote, Inc. All Rights Reserved.</div>
          <div>
            {SvgLanguageIcon}
            <MnInputSelect
              hideBlank={true}
              class="c-mn-select-wrap c-mn-select--no-border"
              value={ this.context.i18n.language }
              groups={ [{ key: 'en', value: 'English' }, { key: 'ja', value: '日本語' }] }
              onChange={ (ev) => {
                this.context.language(ev.value);
              } }
            />
          </div>
        </div>
      </div>
    );
  }
}
